import React from "react";
import SectionTitle from './section-title'
import "./book-page.m.css";

const houseImages = [
  "kfik7ppm/abon.png",
  "okam17l3/skip.png",
  "6w82q18c/hoard.png",
  "dmxnire5/crack.png",
];

export default function HouseBlocks() {
  return (
    <section styleName="house-blocks">
      <SectionTitle
        title="We Welcome All The Reading Criminals:"
        width="30%"
      />

      <div styleName="house-grid">
        {houseImages.map((img, index) => (
          <div key={index} styleName="house-card">
            <img
              loading="lazy"
              src={`https://images.assettype.com/newslaundry/2026-06-29/${img}`}
              alt=""
              styleName="house-image"
            />
          </div>
        ))}
      </div>
    </section>
  );
}